import styled from "styled-components";

export const PolygonArtStyled = styled.div`
  width: 100%;
  padding-bottom: 4rem;
`;
